/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Why_TitleInputs */

const es_home_why_title = /** @type {(inputs: Home_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué elegir Nexata?`)
};

const en_home_why_title = /** @type {(inputs: Home_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why choose Nexata?`)
};

/**
* | output |
* | --- |
* | "Why choose Nexata?" |
*
* @param {Home_Why_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_why_title = /** @type {((inputs?: Home_Why_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Why_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_why_title(inputs)
	return en_home_why_title(inputs)
});
export { home_why_title as "home.why.title" }